// extracted by mini-css-extract-plugin
export default {"wrapper":"Info_wrapper__FRaKE"};